import { motion } from 'framer-motion';

const ShweebumCat = ({ size = "md", speaking = false }) => {
  const sizes = {
    sm: "w-12 h-12",
    md: "w-24 h-24",
    lg: "w-40 h-40"
  };
  
  return (
    <div className={`${sizes[size]} relative`}>
      <img 
        src="https://static.prod-images.emergentagent.com/jobs/24973f31-8eb2-4fbe-846a-660e5ee7d5a4/images/76ca5066536b66309769ee7e3059f0f32a579b4425ff451f97a25e283239eaf6.png"
        alt="Shweebum the cat"
        className="w-full h-full object-contain"
      />
      {speaking && (
        <motion.div 
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          className="absolute -top-2 -right-2 bg-yellow-100 text-yellow-800 text-xs px-2 py-1 rounded-full"
        >
          meow!
        </motion.div>
      )}
    </div>
  );
};

export default ShweebumCat;
